import { render, staticRenderFns } from "./egym-round-preview.component.vue?vue&type=template&id=42e1eb94&scoped=true"
import script from "./egym-round-preview.component.ts?vue&type=script&lang=ts&external"
export * from "./egym-round-preview.component.ts?vue&type=script&lang=ts&external"
import style0 from "./egym-round-preview.component.scss?vue&type=style&index=0&id=42e1eb94&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e1eb94",
  null
  
)

export default component.exports